// extracted by css-extract-rspack-plugin
export default {"contentfulHeroContainer":"ContentfulHero-module__contentfulHeroContainer__Mywny","heroVideo":"ContentfulHero-module__heroVideo__By21Y"};